import type { IconData } from '@stacksjs/iconify-core'

export const dk1x1: IconData = {
  "body": "<path fill=\"#c8102e\" d=\"M0 0h512.1v512H0z\"/><path fill=\"#fff\" d=\"M144 0h73.1v512H144z\"/><path fill=\"#fff\" d=\"M0 219.4h512.1v73.2H0z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default dk1x1
